export default "__VITE_ASSET__Btv0LbJ9__"